import { CloudDownloadOutlined } from '@ant-design/icons';
import { Button, Space, Table, Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useDispatch, useSelector } from 'react-redux';
import { IDocument } from '../../../../interfaces/documents/data/IDocument';
import { IInvoiceDocumentTableRow } from '../../../../interfaces/documents/IInvoiceDocumentTableRow';
import { AppDispatch, RootState } from '../../../../store';
import { downloadDocument } from '../../../../store/documentSlice/DocumentActions';
import dayjs from 'dayjs';
import './InvoiceDocumentTable.less';

export interface IInvoiceDocumentTableProps {}

export const InvoiceDocumentTable = (props: IInvoiceDocumentTableProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const invoiceSlice = useSelector((state: RootState) => state.invoiceSlice);

    const columns: ColumnsType<IInvoiceDocumentTableRow> = [
        {
            title: 'Document #',
            dataIndex: 'document',
            key: 'document',
            render: (doc: IDocument) => <>{doc.id}</>,
        },
        {
            title: 'Filename',
            dataIndex: 'document',
            key: 'document',
            render: (doc: IDocument) => <>{doc.fileName}</>,
        },
        {
            title: 'Created',
            dataIndex: 'document',
            key: 'document',
            render: (doc: IDocument) => <>{doc?.created && dayjs(doc.created).format('DD-MM-YYYY')}</>,
        },
        {
            title: 'Created by',
            dataIndex: 'document',
            key: 'document',
            render: (doc: IDocument) => <>{doc?.createdBy && <Tooltip title={doc.createdBy.name}>{doc.createdBy.initials}</Tooltip>}</>,
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: 100,
            fixed: 'right',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        type="text"
                        icon={<CloudDownloadOutlined />}
                        onClick={() => dispatch(downloadDocument({ id: record.document.id, fileName: record.document.fileName || '' }))}
                    />
                </Space>
            ),
        },
    ];

    return (
        <Table
            size="small"
            bordered={true}
            columns={columns}
            pagination={false}
            dataSource={
                // Map fees to an array of IInvoiceDocumentTableRow
                invoiceSlice.detailPage?.invoiceDocuments.data.map((i) => {
                    return {
                        ...i,
                        key: i.id,
                    } as IInvoiceDocumentTableRow;
                })
            }
        />
    );
};
